import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-bar-sessions-chart',
  templateUrl: './bar-sessions-chart.component.html',
  styleUrl: './bar-sessions-chart.component.scss',
})
export class BarSessionsChartComponent {
  isLoading = true;
  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.barSessions$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('barSessions');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getBarSessions().subscribe();
  }

  get data() {
    return this.analyticsService.barSessions$.value;
  }
}
